/**
 * Is this business a salon (a place with several masters) rather than a single
 * master?
 *
 * The flag is written under TWO different names in the live data: the
 * registration form writes `type`, while every salon actually in the database
 * carries `businessType`. Code that checked only one of them silently treated
 * salons as solo masters — the salon's QR sticker pointed at /master instead of
 * the master picker, and the "team" panel never appeared for its owner. Read
 * both, everywhere, through here.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isSalon(biz: Record<string, any> | null | undefined): boolean {
  if (!biz) return false;
  return biz.businessType === 'salon' || biz.type === 'salon';
}

/** Public page a business is booked through: /salon (pick a master) or /master. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function businessPath(biz: Record<string, any> | null | undefined): 'salon' | 'master' {
  return isSalon(biz) ? 'salon' : 'master';
}
